import { idFromPointer } from '../../utils/pointer';
import { routePathsById } from '../getRoutePath';

const getRoutePathFromLauncherUri = (
  uri: string | null
): string | undefined => {
  if (!uri) return;

  const id = idFromPointer({
    uri: decodeURIComponent(uri).replace('/player', ''),
  });

  const isPlayerUri = uri !== null && uri.includes('/player');

  return isPlayerUri
    ? routePathsById.player(id)
    : uri.includes('packages')
      ? routePathsById.package(id)
      : routePathsById.item(id);
};

export default getRoutePathFromLauncherUri;
